/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Admission Platform API - Tenants
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTenantRequest,
  Tenant,
  UpdateTenantRequest
} from './model/tenants';





/**
 * @summary List all tenants
 */
export type listTenantsResponse200 = {
  data: Tenant[]
  status: 200
}

export type listTenantsResponseSuccess = (listTenantsResponse200) & {
  headers: Headers;
};
;

export type listTenantsResponse = (listTenantsResponseSuccess)

export const getListTenantsUrl = () => {


  

  return `/api/tenants`
}

export const listTenants = async ( options?: RequestInit): Promise<listTenantsResponse> => {
  
  const res = await fetch(getListTenantsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: listTenantsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listTenantsResponse
}





export const getListTenantsQueryKey = () => {
    return [
    `/api/tenants`
    ] as const;
    }

    
export const getListTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTenants>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenants>>> = ({ signal }) => listTenants({ signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>
export type ListTenantsQueryError = unknown


/**
 * @summary List all tenants
 */

export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Create a new tenant
 */
export type createTenantResponse201 = {
  data: Tenant
  status: 201
}

export type createTenantResponseSuccess = (createTenantResponse201) & {
  headers: Headers;
};
;

export type createTenantResponse = (createTenantResponseSuccess)

export const getCreateTenantUrl = () => {


  

  return `/api/tenants`
}

export const createTenant = async (createTenantRequest: CreateTenantRequest, options?: RequestInit): Promise<createTenantResponse> => {
  
  const res = await fetch(getCreateTenantUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTenantRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: createTenantResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createTenantResponse
}




export const getCreateTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext> => {

const mutationKey = ['createTenant'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenant>>, {data: CreateTenantRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTenant(data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createTenant>>>
    export type CreateTenantMutationBody = CreateTenantRequest
    export type CreateTenantMutationError = unknown

    /**
 * @summary Create a new tenant
 */
export const useCreateTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTenant>>,
        TError,
        {data: CreateTenantRequest},
        TContext
      > => {
      return useMutation(getCreateTenantMutationOptions(options));
    }
    
/**
 * @summary Get tenant by ID
 */
export type getTenantResponse200 = {
  data: Tenant
  status: 200
}

export type getTenantResponseSuccess = (getTenantResponse200) & {
  headers: Headers;
};
;

export type getTenantResponse = (getTenantResponseSuccess)

export const getGetTenantUrl = (id: string,) => {


  

  return `/api/tenants/${id}`
}

export const getTenant = async (id: string, options?: RequestInit): Promise<getTenantResponse> => {
  
  const res = await fetch(getGetTenantUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getTenantResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getTenantResponse
}





export const getGetTenantQueryKey = (id: string,) => {
    return [
    `/api/tenants/${id}`
    ] as const;
    }

    
export const getGetTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTenant>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenant>>> = ({ signal }) => getTenant(id, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTenant>>>
export type GetTenantQueryError = unknown


/**
 * @summary Get tenant by ID
 */

export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTenantQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Update tenant
 */
export type updateTenantResponse200 = {
  data: Tenant
  status: 200
}

export type updateTenantResponseSuccess = (updateTenantResponse200) & {
  headers: Headers;
};
;

export type updateTenantResponse = (updateTenantResponseSuccess)

export const getUpdateTenantUrl = (id: string,) => {


  

  return `/api/tenants/${id}`
}

export const updateTenant = async (id: string,
    updateTenantRequest: UpdateTenantRequest, options?: RequestInit): Promise<updateTenantResponse> => {
  
  const res = await fetch(getUpdateTenantUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTenantRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: updateTenantResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateTenantResponse
}




export const getUpdateTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: string;data: UpdateTenantRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: string;data: UpdateTenantRequest}, TContext> => {

const mutationKey = ['updateTenant'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenant>>, {id: string;data: UpdateTenantRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTenant(id,data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenant>>>
    export type UpdateTenantMutationBody = UpdateTenantRequest
    export type UpdateTenantMutationError = unknown

    /**
 * @summary Update tenant
 */
export const useUpdateTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: string;data: UpdateTenantRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTenant>>,
        TError,
        {id: string;data: UpdateTenantRequest},
        TContext
      > => {
      return useMutation(getUpdateTenantMutationOptions(options));
    }
    
